"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _shareRecommendationSelectors = require("../../store/shareRecommendation/shareRecommendationSelectors");
var _shareRecommendationActions = require("../../store/shareRecommendation/shareRecommendationActions");
var _useEmailRecommendation = require("../../hooks/shareRecommendation/useEmailRecommendation");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../../hooks/useAppDispatch");
var _useAppSelector = require("../../hooks/useAppSelector");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const EmailInput = () => {
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const isShown = (0, _useAppSelector.useAppSelector)(_shareRecommendationSelectors.isEmailInputShown);
  const [inputText, setInputText] = (0, _react.useState)('');
  const [inputState, setInputState] = _react.default.useState();
  const {
    selectedHandset,
    selectedPlan,
    selectedBroadband,
    selectedBusinessSolution,
    selectedUpsellingProducts,
    selectedConnectivityPlan
  } = (0, _useEmailRecommendation.useEmailRecommendation)();
  const recommendedProducts = [{
    id: selectedHandset === null || selectedHandset === void 0 ? void 0 : selectedHandset.variantId,
    type: _constants.PRODUCT_TYPES.HANDSET
  }, {
    id: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantId,
    type: _constants.PRODUCT_TYPES.PLAN
  }, {
    id: selectedBroadband === null || selectedBroadband === void 0 ? void 0 : selectedBroadband.variantId,
    type: _constants.PRODUCT_TYPES.BROADBAND
  }, {
    id: selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : selectedBusinessSolution.variantId,
    type: _constants.PRODUCT_TYPES.BUSINESS_SOLUTION
  }].filter(product => product.id);
  const upsellProducts = selectedUpsellingProducts === null || selectedUpsellingProducts === void 0 ? void 0 : selectedUpsellingProducts.map(product => {
    var _product$selectedVari;
    return {
      id: (product === null || product === void 0 ? void 0 : (_product$selectedVari = product.selectedVariant) === null || _product$selectedVari === void 0 ? void 0 : _product$selectedVari.id) || (product === null || product === void 0 ? void 0 : product.id),
      type: product === null || product === void 0 ? void 0 : product.productType,
      ...((product === null || product === void 0 ? void 0 : product.selectedPrice) && {
        price: {
          upfront: product.selectedPrice.upfront,
          recurring: product.selectedPrice.monthlyPrice,
          recurringAmount: product.selectedPrice.monthlyPeriod
        }
      })
    };
  });
  if (selectedConnectivityPlan.selected) upsellProducts.push({
    id: selectedConnectivityPlan.offering.id,
    type: 'Connectivity Plan'
  });
  const emailBody = {
    recommendedProducts,
    upsellProducts
  };
  const onSendHandle = () => {
    const parsedData = {
      type: 'email',
      subject: 'Your Recommendation',
      status: 'pending',
      to: inputText,
      body: emailBody
    };
    dispatch((0, _shareRecommendationActions.sendRecommendation)(parsedData));
  };
  const onChangeHandle = value => {
    setInputText(value);
    setInputState('');
  };
  const validateInput = () => {
    if (!inputText.match(/^[a-zA-Zα-ωΑ-Ω0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/)) return setInputState('error');
    setInputState();
  };
  return isShown && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    justify: "center"
  }, _services.locale.localeString('ShareRecommendation.Title')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    colMd: 7
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    state: inputState,
    fieldWrapper: {
      width: 'default',
      stateText: _services.locale.localeString('ShareRecommendation.errorText')
    },
    textInput: {
      type: 'text',
      id: 'share-input',
      placeholder: _services.locale.localeString('ShareRecommendation.InputPlaceholder'),
      value: inputText,
      onChange: e => onChangeHandle(e.target.value),
      onBlur: validateInput
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    colMd: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 2,
      left: breakpoints.sm ? 0 : 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, _extends({
    text: _services.locale.localeString('ShareRecommendation.SendButtonText'),
    appearance: "alt1"
  }, inputText.length < 1 && {
    state: 'disabled'
  }, !inputState && {
    onClick: onSendHandle
  })))))));
};
var _default = EmailInput;
exports.default = _default;